import EFPicture from '@elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function MaximizeEnergy() {
    const { useLang, useRouter } = useGlobal();
    // const { t } = useLang('solar_panel_125w');
    const { t } = useLang('theProduct.MaximizeEnergy');

    const { locale } = useRouter();

    const items = [
        {
            title: 'upgraded_solar_cells_title_1',
            text: [t('upgraded_solar_cells_desc_1_1'), t('upgraded_solar_cells_desc_1_2')],
        },
        {
            title: 'upgraded_solar_cells_title_2',
            text: t('upgraded_solar_cells_desc_2_1'),
        },
        {
            title: 'upgraded_solar_cells_title_3',
            text: [t('upgraded_solar_cells_desc_3_1'), t('upgraded_solar_cells_desc_3_2')],
        },
        {
            title: 'upgraded_solar_cells_title_4',
            text: [t('upgraded_solar_cells_desc_4_1'), t('upgraded_solar_cells_desc_4_2')],
        },
    ];

    const IMG_MAP = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731921027239/125w_maximize.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924275013/125w_maximize_h5.jpg',
        },
    };
    const IMGS = IMG_MAP[locale as keyof typeof IMG_MAP] || IMG_MAP.us;

    const ENERGY_ARR = [
        {
            title: t('maximize_energy_1'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1731920864230/125w_maximize_1.jpg',
        },
        {
            title: t('maximize_energy_2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1731920865123/125w_maximize_2.jpg',
        },
        {
            title: t('maximize_energy_3'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1731920864929/125w_maximize_3.jpg',
        },
        {
            title: t('maximize_energy_4'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1731920864665/125w_maximize_4.jpg',
        },
        {
            title: t('maximize_energy_5'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1731920864417/125w_maximize_5.jpg',
        },
    ];

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />

            <div className="info">
                <p className="subtitle">{t('maximize_energy_label')}</p>
                <p className="title">{t('maximize_energy_title')}</p>
                <p className="desc">
                    {t.rich('maximize_energy_desc', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </p>
            </div>
            <div className="maximize-energy-box">
                {ENERGY_ARR.map((item, index) => (
                    <div key={index} className={`energy-item energy-item-${index + 1}`}>
                        <div className="energy-item-img">
                            <EFPicture src={item?.img} srcPad={item?.img} srcMobile={item?.img} alt={item?.title} />
                        </div>
                        <div className="energy-item-title">
                            {t.rich(`maximize_energy_${index + 1}`, {
                                type: (text: string) => <p className="item-title-small">{text}</p>,
                            })}
                        </div>
                    </div>
                ))}
            </div>
            <div className="img-box">
                <EFPicture src={IMGS.pc} srcPad={IMGS.h5} srcMobile={IMGS.h5} alt={t('C_title')} />
            </div>
            <div className="box">
                <p className="box-title">{t('upgraded_solar_cells_title')}</p>
                <ul className="box-items">
                    {items?.map((item: any, k: number) => (
                        <li className={`item item-${k}`} key={k}>
                            <p className="item-title">
                                {t.rich(item.title, {
                                    highLight: (text: string) => <span className="highLight-text">{text}</span>,
                                    highLight2: (text: string) => <span className="highLight2-text">{text}</span>,
                                })}
                            </p>
                            {Array.isArray(item?.text) ? (
                                <ul className="item-lists">
                                    {item?.text?.map((list: any, m: number) => (
                                        <li className="item-list" key={`${k}_${m}`}>
                                            <p className={`bar ${m === 0 ? 'gray' : 'blue'}`}></p>
                                            <p className="item-text">{list}</p>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="item-text">{item.text}</p>
                            )}
                        </li>
                    ))}
                    <p className="dash"></p>
                </ul>
            </div>
            <p className="tip">{t('upgraded_solar_tips')}</p>
        </div>
    );
}
